export class EmailsSettings {

  public id: number;
  public enabled: boolean;
  public value: string;
  public default: string;
  public tip: string;
  public label: string;
  public description: string;

}
